<template>
    <DataTable ref="documentsTable" :value="documents" dataKey="id">
        <Column field="date" :header="$t('message.horseEdit.documents.date')" class="w-2">
            <template #body="{ data }">
                {{ data.creationDate }}
            </template>
        </Column>
        <Column field="type" :header="$t('message.horseEdit.documents.documentType')" class="w-2">
            <template #body="{ data }">
                {{ data.documentType }}
            </template>
        </Column>
        <Column field="file" :header="$t('message.horseEdit.documents.downloadPdf')" class="w-2">
            <template #body="{ data }">
                <CustomIconButton icon="pi pi-download" onlyIcon @click="downloadPdf(data)"/>
            </template>

        </Column>
        <template #empty>
            {{ $t('message.other.emptyTable') }}
        </template>
    </DataTable>
</template>

<script>
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import CustomIconButton from "@/components/form/CustomIconButton.vue";
    import {FileUtils} from "@/utils/FileUtils";

    export default {
        name: "HorseEditDocumentsTable",
        components: {
            CustomIconButton,
            Column,
            DataTable,
        },

        data() {
            return {
                loading: false,
            };
        },

        props: {
            horse: null,
            documents: null,
        },

        methods: {
            downloadPdf(file) {
                const fileName = FileUtils.toSafeFileName(this.horse.name + "_" + file.documentType, "pdf", this.documentType);
                const url = `/files/${encodeURIComponent(file.id)}`;

                FileUtils.downloadFileUsingGET(fileName, url);
            },
        },

    };
</script>

<style lang="scss" scoped>

</style>
